// extracted by mini-css-extract-plugin
export default {"page":"page_page__NWf2H","title":"page_title__xL1kF","divider":"page_divider__MDOC2"};